import mapData from "lib/stores/mapData";

export default function getMobileMapDimensions() {
  const wrapper = document.getElementById("deckgl-wrapper-wrapper");
  const topBar = document.getElementById("toolbar-map-navigation");
  const topBarBottom = topBar.getBoundingClientRect().bottom;
  const primaryControlsBarMobile = document.getElementById("primary-controls-bar-mobile");

  const primaryControlsBarMobileBottom = primaryControlsBarMobile.getBoundingClientRect().top;
  const bottomPanelHeight = window.innerHeight - primaryControlsBarMobileBottom;

  const height = window.innerHeight - (topBarBottom + bottomPanelHeight);
  const topBarBottomAdjustment = document.querySelector("header")?.clientHeight ?? 0;
  let top = topBarBottom;
  if (window.innerWidth > 1023) {
    top = topBarBottom - topBarBottomAdjustment;
  }
  if (window.innerWidth <= 1023) {
    wrapper.style.height = `${height}px`;
    wrapper.style.top = `${top}px`;
    mapData.viewState.minZoom = -1.0;
    mapData.viewState.zoom = -1.0;
    mapData.viewState.longitude = 0;
    mapData.viewState.latitude = 0;
  } else {
    wrapper.style.height = `${
      window.innerHeight -
      document.getElementById("toolbar-map-navigation").clientHeight -
      document.getElementById("toolbar-map-navigation").clientHeight
    }px`;
    wrapper.style.top = `${top}px`;
    mapData.viewState.minZoom = -1.0;
    mapData.viewState.zoom = -1.0;
    mapData.viewState.longitude = 0;
    mapData.viewState.latitude = 0;
    // wrapper.style.height = "100%";
    // wrapper.style.top = "0";
    // mapData.viewState.minZoom = 1;
    // mapData.viewState.zoom = 2;
    // mapData.viewState.latitude = 44;
  }
}
